import { Divider } from "@mui/material";
import ServerElement from "./ServerElement";
import useServerElements from "../hooks/useServerElements";
import { IUseServerElementsProps } from "../types/serverElements";

const ServerElementsWithoutActions = ({
  groupName
}: IUseServerElementsProps) => {
  const { elementsWithoutActions } = useServerElements({groupName});


  return (elementsWithoutActions.length > 0 &&
    <>
      <Divider/>
      {elementsWithoutActions.map((element, idx) => (
        <div key={idx}>
          <ServerElement htmlElement={element}/>
        </div>
      ))}
    </>
  )
}

export default ServerElementsWithoutActions;